import React from 'react';

const defaultCustomerContextValue = {
  membershipInformation: null,
};

export const CustomerContext = React.createContext(defaultCustomerContextValue);